// extracted by mini-css-extract-plugin
export var completionBody = "_l5-2";
export var completionCard = "_l5-0";
export var completionFooter = "_l5-3";
export var completionTitle = "_l5-1";